<app-dashboard #dashboard [aggregationsType]="'enterpriseAi'">
  <div class="chart-container" *ngIf="dashboard.aggregationsModel$ | async as aggregationModel">
    <app-line-chart
      class="copilot-adoption"
      [title]="'enterpriseAiDashboardPage.copilotsAdoptionTitle' | labelsProvider"
      [tooltip]="'enterpriseAiDashboardPage.copilotsAdoptionTooltip' | labelsProvider"
      [seriesDetails]="aggregationModel | chartData: 'copilotsAdoption'"
      [yAxisLabelType]="'value'"
    >
    </app-line-chart>

    <app-pie-animation-chart
      class="ai-owasp-risk-distribution"
      [title]="'enterpriseAiDashboardPage.owaspRiskDistributionForAiTitle' | labelsProvider"
      [tooltip]="'enterpriseAiDashboardPage.owaspRiskDistributionForAiTooltip' | labelsProvider"
      [seriesDetails]="aggregationModel | chartData: 'owaspRiskDistributionForAi'"
    >
    </app-pie-animation-chart>

    <div class="ai-plugin-types">
      <app-pie-animation-chart
        class="part-chart-40"
        [title]="'enterpriseAiDashboardPage.m365copilotPluginTypesDistributionTitle' | labelsProvider"
        [tooltip]="'enterpriseAiDashboardPage.m365copilotPluginTypesDistributionTooltip' | labelsProvider"
        [seriesDetails]="aggregationModel | chartData: 'm365copilotPluginTypesDistribution'"
        [selectedFilters]="(dashboard.selectedFilter$ | async)!"
      >
      </app-pie-animation-chart>

      <app-top-ai-plugins-data-chart
        class="part-chart-60"
        [seriesData]="aggregationModel | chartData: 'm365copilotTopPlugins'"
      >
      </app-top-ai-plugins-data-chart>
    </div>

    <app-pie-animation-chart
      class="ai-open-violations"
      [title]="'enterpriseAiDashboardPage.openViolationsSeverityDistributionForAiTitle' | labelsProvider"
      [tooltip]="'enterpriseAiDashboardPage.openViolationsSeverityDistributionForAiTooltip' | labelsProvider"
      [seriesDetails]="aggregationModel | chartData: 'openViolationsSeverityDistributionForAi'"
      [selectedFilters]="(dashboard.selectedFilter$ | async)!"
    >
    </app-pie-animation-chart>
  </div>
</app-dashboard>
